import {createAction} from 'web-app/util/redux/famly-app-helpers';

import type * as Types from './types';

const domain = 'DIALOG';

export const {action: show} = createAction(`${domain}/OPEN`, <T>(dialog: Types.DialogProps<T>) => ({dialog}));
export const {action: hide} = createAction(`${domain}/HIDE`, (id: string) => ({id}));
